import {useForm} from 'react-hook-form';
import React, {useId} from 'react';
import {User} from '@ui/types/user';
import {AccountSettingsPanel} from '../account-settings-panel';
import {Form} from '@ui/forms/form';
import {useUpdateAccountDetails} from './update-account-details';
import {Trans} from '@ui/i18n/trans';
import {AccountSettingsId} from '@common/auth/ui/account-settings/account-settings-sidenav';
import {FormSwitch} from '@ui/forms/toggle/switch';
import {DebridorsDatatablePageAdmin} from '@common/auth/ui/account-settings/debridors-datatable-page';

interface Props {
  user: User;
}

export function PremiumPanel({user}: Props) {
  const formId = useId();
  const [debridLink, setDebridLink] = React.useState(
    user.more_info?.debrid_link || false,
  );

  const form = useForm<Partial<Omit<User, 'subscriptions'>>>({
    defaultValues: {
      more_info: {
        debrid_link: debridLink,
      },
    },
  });
  const updateDetails = useUpdateAccountDetails(user.id, form);

  return (
    <AccountSettingsPanel
      id={AccountSettingsId.PremiumPanel}
      title={<Trans message="Premium settings" />}
    >
      <Form
        form={form}
        className="flex flex-col items-center gap-40 md:flex-row md:gap-80"
        onSubmit={newDetails => {
          updateDetails.mutate(newDetails);
        }}
        id={formId}
      >
        <div className="w-full flex-auto">
          <FormSwitch
            name={'more_info.debrid_link'}
            className="mt-24"
            checked={debridLink}
            onChangeCapture={e => {
              const checked = (e.target as HTMLInputElement).checked;
              setDebridLink(checked);
              form.setValue('more_info.debrid_link', checked);
              form.handleSubmit((newDetails, e) => {
                updateDetails.mutate(newDetails);
              })();
            }}
            description={
              <Trans message="This feature allows you to retrieve premium links using your Premium hoster or debridor account." />
            }
          >
            <Trans message="Automatic premium link generation" />
          </FormSwitch>
        </div>
      </Form>
      <DebridorsDatatablePageAdmin />
    </AccountSettingsPanel>
  );
}
